import vest, { test, enforce } from "vest";

export const validationSuite = vest.create((data = {}) => {

  test("userName", "Username is required", () => {
    enforce(data.userName).isNotEmpty();
  });

  test("userName", "Username Must be longer than 3 chars", () => {
    enforce(data.userName).longerThan(3);
  });

  test("userName", "Invalid User Name", () => {
    enforce(data.userName).matches(
      /^(?=.{4,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/
    );
  });

  test("password", "Password is required", () => {
    enforce(data.password).isNotEmpty();
  });

  test("password", "Password must be at least 5 chars", () => {
    enforce(data.password).longerThanOrEquals(5);
  });

  test("password", "Password must contain a digit", () => {
    enforce(data.password).matches(/[0-9]/);
  });

  test("password", "Password must contain a symbol", () => {
    enforce(data.password).matches(/[^A-Za-z0-9]/);
  });
});

export const validationSuite2 = vest.create((data = {}) => {
  test("userName", "Username is required", () => {
    enforce(data.userName).isNotEmpty();
  });

  test("userName", "Username is too short", () => {
    enforce(data.userName).longerThanOrEquals(3);
  });

  test("userName", "Invalid User Name", () => {
    enforce(data.userName).matches(
      /^(?=.{4,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/
    );
  });

  test("name", "Name is required", () => {
    enforce(data.name).isNotEmpty();
  });

  test("name", "Name Must be longer than 3 chars", () => {
    enforce(data.name).longerThan(3);
  });

  test("password", "Password is required", () => {
    enforce(data.password).isNotEmpty();
  });

  test("password", "Password must be at least 6 chars long", () => {
    enforce(data.password).longerThanOrEquals(6);
  });

  test("password", "Password is weak, Maybe add a number?", () => {
    vest.warn();
    enforce(data.password).matches(/[0-9]/);
  });

  test("confirmPassword", "Confirm Password is required", () => {
    enforce(data.confirmPassword).isNotEmpty();
  });

  if (data.password) {
    test("confirmPassword", "Passwords do not match", () => {
      enforce(data.confirmPassword).equals(data.password);
    });
  }

  test("email", "Email Address is required", () => {
    enforce(data.userName).isNotEmpty();
  });

  test("email", "Email Address is not valid", () => {
    enforce(data.email).matches(
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
    );
  });
});
